export default __webpack_public_path__ + "c25463af36a1ee13037db9cd454ac4c1.gif";